import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetHeaderParams } from "../interface";
import LandingHeaderMargauxMotin from "design-system/src/Components/WidgetPart/LandingHeader/LandingHeaderMargauxMotin/LandingHeaderMargauxMotin";
import useCtaAction from "@src/components/widgets/hooks/useCtaAction";
import { usePushAppsModal } from "@src/lib/WidgetPushApp/WidgetPushApp";
import { withAssetPrefix } from "gatsby";

const HeaderMargauxMotin: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetHeaderParams>((props) => {
    const { p } = props;
    const logoId = p("logo");
    const cta_action = p("cta_action");
    const productId = p("product");
    const attachPushApps: boolean =  p("attach_to_push_apps") === "1";
    const { generateClick } = useCtaAction(productId || "");
    const { openModal, canShowPushApps } = usePushAppsModal();

    const onClick = generateClick(
      cta_action && cta_action === "open_link"
        ? {
            type: cta_action,
            link: p("link") || "#",
          }
        : {
            type: cta_action || "product_card",
          }
    );
    const handleClick = () => {
      if (attachPushApps && canShowPushApps()) {
        openModal();
      } else {
        onClick();
      }
    };

    return (
      <LandingHeaderMargauxMotin
        title={p("title") || ""}
        subtitle={p("subtitle")}
        ctaLabel={p("cta_label") || ""}
        description={p("description")}
        image={p("product_image")}
        logoId={logoId}
        onClick={handleClick}
        backgroundImage={{
          desktop: p("background_media_desktop"),
          mobile: p("background_media_mobile"),
        }}
        videoSrc={withAssetPrefix('videos/margaux-motin.mp4')}
      />
    );
  });

export default HeaderMargauxMotin;
